export const STELLAR_BURGER_API = 'https://norma.nomoreparties.space/api';
export const wsUrl = 'wss://norma.nomoreparties.space';